import React, { useMemo } from "react";

import { PageLoader } from "clearsense-ui/components";
import useJobResultData from "hooks/useJobResultData";

import ConfusionMatrix from "./ConfusionMatrix";
import { getConfusionMatrixData, getModelStatisticsData } from "./data";
import ModelStatistics from "./ModelStatistics";

const Quality = ({ isLoading, outputs, setOutputs }) => {
  const { loading: modelQualityLoading, data: modelQuality } = useJobResultData(
    outputs,
    setOutputs,
    "binary_model_quality"
  );

  const confusionMatrixData = useMemo(
    () =>
      modelQuality?.confusion_matrix &&
      getConfusionMatrixData(modelQuality.confusion_matrix),
    [modelQuality]
  );

  const modelStatisticsData = useMemo(
    () =>
      modelQuality?.confusion_matrix?.derived_metrics &&
      getModelStatisticsData(modelQuality.confusion_matrix.derived_metrics),
    [modelQuality]
  );

  if (isLoading || modelQualityLoading) {
    return <PageLoader />;
  }

  return (
    <div className="flex flex-col space-y-8">
      <div className="flex flex-col bg-white dark:bg-gray-800 border-2">
        <ConfusionMatrix data={confusionMatrixData} />
      </div>

      <div className="flex flex-col bg-white dark:bg-gray-800 border-2">
        <ModelStatistics data={modelStatisticsData} />
      </div>
    </div>
  );
};

export default Quality;
